// extracted by mini-css-extract-plugin
var _1 = "ShadeArrow__disabled--WrS47";
var _2 = "ShadeArrow__icon--CeZIZ";
var _3 = "ShadeArrow__left--yFBin ShadeArrow__icon--CeZIZ";
var _4 = "ShadeArrow__main--GVpg5";
var _5 = "ShadeArrow__right--MLlmA ShadeArrow__icon--CeZIZ";
export { _1 as "disabled", _2 as "icon", _3 as "left", _4 as "main", _5 as "right" }
